import { Component, OnInit } from '@angular/core';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MyLoaderComponent } from '../core/components/my-loader/my-loader.component';
import { MatCard } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'app-conversation',
    templateUrl: './conversation.component.html',
    styleUrls: ['./conversation.component.scss'],
    imports: [MatToolbar, MatToolbarRow, MatButton, MatIcon, MyLoaderComponent, MatCard, MatFormField, MatLabel, MatInput]
})
export class ConversationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
